module.exports = __webpack_public_path__ + "img/Middle-Horizontal-Rectangular-Attachment-22.838d94ac.png";